import { useState, useEffect } from "react";
import { Avatar } from "../Avatar";
import InputField from "../input-field/InputField";
import DefaultButton from "../default-button/DefaultButton";
import Edit from "../../assets/icons/Edit";
import { MainUser } from "../../types";

interface StudentAttendance {
    id: number;
    student: MainUser;
    studentId: string;
    isPresent: boolean;
    isLate: boolean;
    score: number;
}

interface AttendanceStudentsTableProps {
    selectedLessonId?: number;
    students?: StudentAttendance[];
    onEditAttendance?: () => void;
    onSearchChange?: (value: string) => void;
    onPresenceFilterChange?: (value: string) => void;
}

// Mock data - should come from API
// Данные студентов по урокам (lessonId -> students)
const mockStudentsByLesson: Record<number, StudentAttendance[]> = {
    1: [
        {
            id: 1,
            student: {
                id: 1,
                external_user_id: 1,
                profile_image: null,
                json_saved_data: {
                    id: 1,
                    role: 'student',
                    email: 'aruzhan@example.com',
                    mobile: '',
                    lastname: 'Барушева',
                    firstname: 'Аружан',
                    department: '',
                    externalId: '123456789',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '123456789',
            isPresent: true,
            isLate: false,
            score: 4
        },
        {
            id: 2,
            student: {
                id: 2,
                external_user_id: 2,
                profile_image: null,
                json_saved_data: {
                    id: 2,
                    role: 'student',
                    email: 'amanay@example.com',
                    mobile: '',
                    lastname: 'Балат',
                    firstname: 'Аманай',
                    department: '',
                    externalId: '345678912',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '345678912',
            isPresent: true,
            isLate: false,
            score: 3
        },
    ],
    2: [
        {
            id: 1,
            student: {
                id: 1,
                external_user_id: 1,
                profile_image: null,
                json_saved_data: {
                    id: 1,
                    role: 'student',
                    email: 'aruzhan@example.com',
                    mobile: '',
                    lastname: 'Барушева',
                    firstname: 'Аружан',
                    department: '',
                    externalId: '123456789',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '123456789',
            isPresent: false,
            isLate: false,
            score: 0
        },
        {
            id: 2,
            student: {
                id: 2,
                external_user_id: 2,
                profile_image: null,
                json_saved_data: {
                    id: 2,
                    role: 'student',
                    email: 'amanay@example.com',
                    mobile: '',
                    lastname: 'Балат',
                    firstname: 'Аманай',
                    department: '',
                    externalId: '345678912',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '345678912',
            isPresent: true,
            isLate: false,
            score: 5
        },
        {
            id: 3,
            student: {
                id: 3,
                external_user_id: 3,
                profile_image: null,
                json_saved_data: {
                    id: 3,
                    role: 'student',
                    email: 'danila@example.com',
                    mobile: '',
                    lastname: 'Дементьев',
                    firstname: 'Данила',
                    department: '',
                    externalId: '567891234',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '567891234',
            isPresent: true,
            isLate: false,
            score: 4
        },
    ],
    3: [
        {
            id: 1,
            student: {
                id: 1,
                external_user_id: 1,
                profile_image: null,
                json_saved_data: {
                    id: 1,
                    role: 'student',
                    email: 'aruzhan@example.com',
                    mobile: '',
                    lastname: 'Барушева',
                    firstname: 'Аружан',
                    department: '',
                    externalId: '123456789',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '123456789',
            isPresent: true,
            isLate: false,
            score: 5
        },
        {
            id: 2,
            student: {
                id: 2,
                external_user_id: 2,
                profile_image: null,
                json_saved_data: {
                    id: 2,
                    role: 'student',
                    email: 'amanay@example.com',
                    mobile: '',
                    lastname: 'Балат',
                    firstname: 'Аманай',
                    department: '',
                    externalId: '345678912',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '345678912',
            isPresent: true,
            isLate: false,
            score: 5
        },
        {
            id: 3,
            student: {
                id: 3,
                external_user_id: 3,
                profile_image: null,
                json_saved_data: {
                    id: 3,
                    role: 'student',
                    email: 'danila@example.com',
                    mobile: '',
                    lastname: 'Дементьев',
                    firstname: 'Данила',
                    department: '',
                    externalId: '567891234',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '567891234',
            isPresent: false,
            isLate: false,
            score: 0
        },
    ],
    // Добавляем данные для остальных уроков (для симуляции)
    4: [
        {
            id: 1,
            student: {
                id: 1,
                external_user_id: 1,
                profile_image: null,
                json_saved_data: {
                    id: 1,
                    role: 'student',
                    email: 'aruzhan@example.com',
                    mobile: '',
                    lastname: 'Барушева',
                    firstname: 'Аружан',
                    department: '',
                    externalId: '123456789',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '123456789',
            isPresent: true,
            isLate: false,
            score: 4
        },
        {
            id: 2,
            student: {
                id: 2,
                external_user_id: 2,
                profile_image: null,
                json_saved_data: {
                    id: 2,
                    role: 'student',
                    email: 'amanay@example.com',
                    mobile: '',
                    lastname: 'Балат',
                    firstname: 'Аманай',
                    department: '',
                    externalId: '345678912',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '345678912',
            isPresent: true,
            isLate: false,
            score: 5
        },
    ],
    5: [
        {
            id: 1,
            student: {
                id: 1,
                external_user_id: 1,
                profile_image: null,
                json_saved_data: {
                    id: 1,
                    role: 'student',
                    email: 'aruzhan@example.com',
                    mobile: '',
                    lastname: 'Барушева',
                    firstname: 'Аружан',
                    department: '',
                    externalId: '123456789',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '123456789',
            isPresent: true,
            isLate: false,
            score: 5
        },
        {
            id: 2,
            student: {
                id: 2,
                external_user_id: 2,
                profile_image: null,
                json_saved_data: {
                    id: 2,
                    role: 'student',
                    email: 'amanay@example.com',
                    mobile: '',
                    lastname: 'Балат',
                    firstname: 'Аманай',
                    department: '',
                    externalId: '345678912',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '345678912',
            isPresent: false,
            isLate: false,
            score: 0
        },
        {
            id: 3,
            student: {
                id: 3,
                external_user_id: 3,
                profile_image: null,
                json_saved_data: {
                    id: 3,
                    role: 'student',
                    email: 'danila@example.com',
                    mobile: '',
                    lastname: 'Дементьев',
                    firstname: 'Данила',
                    department: '',
                    externalId: '567891234',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '567891234',
            isPresent: true,
            isLate: false,
            score: 4
        },
    ],
    // Уроки для Introduction to Management (11-14)
    11: [
        {
            id: 1,
            student: {
                id: 1,
                external_user_id: 1,
                profile_image: null,
                json_saved_data: {
                    id: 1,
                    role: 'student',
                    email: 'aruzhan@example.com',
                    mobile: '',
                    lastname: 'Барушева',
                    firstname: 'Аружан',
                    department: '',
                    externalId: '123456789',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '123456789',
            isPresent: true,
            isLate: false,
            score: 5
        },
    ],
    12: [
        {
            id: 1,
            student: {
                id: 1,
                external_user_id: 1,
                profile_image: null,
                json_saved_data: {
                    id: 1,
                    role: 'student',
                    email: 'aruzhan@example.com',
                    mobile: '',
                    lastname: 'Барушева',
                    firstname: 'Аружан',
                    department: '',
                    externalId: '123456789',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '123456789',
            isPresent: true,
            isLate: false,
            score: 4
        },
        {
            id: 2,
            student: {
                id: 2,
                external_user_id: 2,
                profile_image: null,
                json_saved_data: {
                    id: 2,
                    role: 'student',
                    email: 'amanay@example.com',
                    mobile: '',
                    lastname: 'Балат',
                    firstname: 'Аманай',
                    department: '',
                    externalId: '345678912',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '345678912',
            isPresent: true,
            isLate: false,
            score: 5
        },
    ],
    13: [
        {
            id: 1,
            student: {
                id: 1,
                external_user_id: 1,
                profile_image: null,
                json_saved_data: {
                    id: 1,
                    role: 'student',
                    email: 'aruzhan@example.com',
                    mobile: '',
                    lastname: 'Барушева',
                    firstname: 'Аружан',
                    department: '',
                    externalId: '123456789',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '123456789',
            isPresent: false,
            isLate: false,
            score: 0
        },
    ],
    14: [
        {
            id: 1,
            student: {
                id: 1,
                external_user_id: 1,
                profile_image: null,
                json_saved_data: {
                    id: 1,
                    role: 'student',
                    email: 'aruzhan@example.com',
                    mobile: '',
                    lastname: 'Барушева',
                    firstname: 'Аружан',
                    department: '',
                    externalId: '123456789',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '123456789',
            isPresent: true,
            isLate: false,
            score: 5
        },
        {
            id: 3,
            student: {
                id: 3,
                external_user_id: 3,
                profile_image: null,
                json_saved_data: {
                    id: 3,
                    role: 'student',
                    email: 'danila@example.com',
                    mobile: '',
                    lastname: 'Дементьев',
                    firstname: 'Данила',
                    department: '',
                    externalId: '567891234',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '567891234',
            isPresent: true,
            isLate: false,
            score: 4
        },
    ],
    // Уроки для ICT (21-25)
    21: [
        {
            id: 2,
            student: {
                id: 2,
                external_user_id: 2,
                profile_image: null,
                json_saved_data: {
                    id: 2,
                    role: 'student',
                    email: 'amanay@example.com',
                    mobile: '',
                    lastname: 'Балат',
                    firstname: 'Аманай',
                    department: '',
                    externalId: '345678912',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '345678912',
            isPresent: true,
            isLate: false,
            score: 4
        },
    ],
    22: [
        {
            id: 2,
            student: {
                id: 2,
                external_user_id: 2,
                profile_image: null,
                json_saved_data: {
                    id: 2,
                    role: 'student',
                    email: 'amanay@example.com',
                    mobile: '',
                    lastname: 'Балат',
                    firstname: 'Аманай',
                    department: '',
                    externalId: '345678912',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '345678912',
            isPresent: true,
            isLate: false,
            score: 5
        },
        {
            id: 3,
            student: {
                id: 3,
                external_user_id: 3,
                profile_image: null,
                json_saved_data: {
                    id: 3,
                    role: 'student',
                    email: 'danila@example.com',
                    mobile: '',
                    lastname: 'Дементьев',
                    firstname: 'Данила',
                    department: '',
                    externalId: '567891234',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '567891234',
            isPresent: false,
            isLate: false,
            score: 0
        },
    ],
    23: [
        {
            id: 2,
            student: {
                id: 2,
                external_user_id: 2,
                profile_image: null,
                json_saved_data: {
                    id: 2,
                    role: 'student',
                    email: 'amanay@example.com',
                    mobile: '',
                    lastname: 'Балат',
                    firstname: 'Аманай',
                    department: '',
                    externalId: '345678912',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '345678912',
            isPresent: true,
            isLate: false,
            score: 5
        },
        {
            id: 3,
            student: {
                id: 3,
                external_user_id: 3,
                profile_image: null,
                json_saved_data: {
                    id: 3,
                    role: 'student',
                    email: 'danila@example.com',
                    mobile: '',
                    lastname: 'Дементьев',
                    firstname: 'Данила',
                    department: '',
                    externalId: '567891234',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '567891234',
            isPresent: true,
            isLate: false,
            score: 4
        },
    ],
    24: [
        {
            id: 3,
            student: {
                id: 3,
                external_user_id: 3,
                profile_image: null,
                json_saved_data: {
                    id: 3,
                    role: 'student',
                    email: 'danila@example.com',
                    mobile: '',
                    lastname: 'Дементьев',
                    firstname: 'Данила',
                    department: '',
                    externalId: '567891234',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '567891234',
            isPresent: true,
            isLate: false,
            score: 5
        },
    ],
    25: [
        {
            id: 2,
            student: {
                id: 2,
                external_user_id: 2,
                profile_image: null,
                json_saved_data: {
                    id: 2,
                    role: 'student',
                    email: 'amanay@example.com',
                    mobile: '',
                    lastname: 'Балат',
                    firstname: 'Аманай',
                    department: '',
                    externalId: '345678912',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '345678912',
            isPresent: true,
            isLate: false,
            score: 4
        },
        {
            id: 3,
            student: {
                id: 3,
                external_user_id: 3,
                profile_image: null,
                json_saved_data: {
                    id: 3,
                    role: 'student',
                    email: 'danila@example.com',
                    mobile: '',
                    lastname: 'Дементьев',
                    firstname: 'Данила',
                    department: '',
                    externalId: '567891234',
                    yearOfStudy: null,
                    organization: '',
                    organizationId: 0,
                    subOrganization: '',
                    subOrganizationId: 0
                }
            },
            studentId: '567891234',
            isPresent: true,
            isLate: false,
            score: 5
        },
    ],
};

// Функция для получения студентов по уроку (симуляция API)
const getStudentsByLesson = (lessonId?: number): StudentAttendance[] => {
    if (!lessonId) return [];
    return mockStudentsByLesson[lessonId] || [];
};

export default function AttendanceStudentsTable({
    selectedLessonId,
    students,
    onEditAttendance,
    onSearchChange,
    onPresenceFilterChange
}: AttendanceStudentsTableProps) {
    // Получаем студентов для урока (используем переданные students или получаем из мока)
    const lessonStudents = students !== undefined ? students : getStudentsByLesson(selectedLessonId);
    
    const [search, setSearch] = useState("");
    const [presenceFilter, setPresenceFilter] = useState("all");
    const [sortBy, setSortBy] = useState<{ field: 'name' | 'id' | 'presence' | 'score' | null; direction: 'asc' | 'desc' }>({ field: null, direction: 'asc' });
    const [isEditMode, setIsEditMode] = useState(false);
    const [editedStudents, setEditedStudents] = useState<StudentAttendance[]>(lessonStudents);

    // Обновляем editedStudents при изменении students или selectedLessonId
    useEffect(() => {
        const currentStudents = students !== undefined ? students : getStudentsByLesson(selectedLessonId);
        setEditedStudents(currentStudents);
        setIsEditMode(false);
    }, [students, selectedLessonId]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearch(value);
        onSearchChange?.(value);
    };

    const handlePresenceFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        setPresenceFilter(value);
        onPresenceFilterChange?.(value);
    };

    const handleSort = (field: 'name' | 'id' | 'presence' | 'score') => {
        setSortBy(prev => ({
            field,
            direction: prev.field === field && prev.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    const handleEditClick = () => {
        const currentStudents = students !== undefined ? students : getStudentsByLesson(selectedLessonId);
        setIsEditMode(true);
        setEditedStudents([...currentStudents]);
        onEditAttendance?.();
    };

    const handleSaveChanges = () => {
        // TODO: Сохранить изменения через API
        console.log("Saving attendance changes for lesson", selectedLessonId, ":", editedStudents);
        setIsEditMode(false);
        // В реальном приложении здесь будет вызов API для сохранения изменений
        // Например: await attendanceApi.updateAttendance(selectedLessonId, editedStudents);
    };

    const handleCancelEdit = () => {
        const currentStudents = students !== undefined ? students : getStudentsByLesson(selectedLessonId);
        setEditedStudents(currentStudents);
        setIsEditMode(false);
    };

    const handlePresenceChange = (studentId: number, value: string) => {
        setEditedStudents(prev => 
            prev.map(student => 
                student.id === studentId 
                    ? { 
                        ...student, 
                        isPresent: value === 'yes' || value === 'late',
                        isLate: value === 'late'
                    }
                    : student
            )
        );
    };

    const handleScoreChange = (studentId: number, score: number) => {
        setEditedStudents(prev => 
            prev.map(student => 
                student.id === studentId 
                    ? { ...student, score }
                    : student
            )
        );
    };

    // Используем editedStudents для фильтрации и сортировки
    const currentStudents = students !== undefined ? students : getStudentsByLesson(selectedLessonId);
    const studentsToDisplay = isEditMode ? editedStudents : currentStudents;
    
    const filteredStudents = studentsToDisplay.filter(student => {
        const matchesSearch = search === "" || 
            student.student.json_saved_data.firstname.toLowerCase().includes(search.toLowerCase()) ||
            student.student.json_saved_data.lastname.toLowerCase().includes(search.toLowerCase()) ||
            student.studentId.includes(search);
        
        const matchesPresence = presenceFilter === "all" ||
            (presenceFilter === "present" && student.isPresent) ||
            (presenceFilter === "absent" && !student.isPresent) ||
            (presenceFilter === "late" && student.isLate);
        
        return matchesSearch && matchesPresence;
    });

    const sortedStudents = [...filteredStudents].sort((a, b) => {
        if (!sortBy.field) return 0;
        if (sortBy.field === 'name') {
            const nameA = `${a.student.json_saved_data.firstname} ${a.student.json_saved_data.lastname}`;
            const nameB = `${b.student.json_saved_data.firstname} ${b.student.json_saved_data.lastname}`;
            return sortBy.direction === 'asc'
                ? nameA.localeCompare(nameB)
                : nameB.localeCompare(nameA);
        } else if (sortBy.field === 'id') {
            return sortBy.direction === 'asc'
                ? a.studentId.localeCompare(b.studentId)
                : b.studentId.localeCompare(a.studentId);
        } else if (sortBy.field === 'presence') {
            return sortBy.direction === 'asc'
                ? (a.isPresent === b.isPresent ? 0 : a.isPresent ? 1 : -1)
                : (a.isPresent === b.isPresent ? 0 : a.isPresent ? -1 : 1);
        } else {
            return sortBy.direction === 'asc'
                ? a.score - b.score
                : b.score - a.score;
        }
    });

    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
                <InputField
                    type="text"
                    placeholder="Поиск"
                    value={search}
                    handleChange={handleSearchChange}
                    wrapperClassName="flex-4"
                    additionalClassName="!bg-[#F0F3FA] py-2 px-4 rounded-lg w-full border-none"
                />
                <div>
                <div className="flex flex-1 items-center gap-2">
                    <div className="text-sm font-semibold text-valley-gray">Присутствие</div>
                        <select
                            className="!bg-[#F0F3FA] py-2 px-4 rounded-lg border-none"
                            value={presenceFilter}
                            onChange={handlePresenceFilterChange}
                        > 
                            <option value="all">Все</option>
                            <option value="present">Присутствует</option>
                            <option value="absent">Отсутствует</option>
                            <option value="late">Опоздал</option>
                        </select>
                    </div>
                </div>
                
                {!isEditMode ? (
                    <DefaultButton
                        Icon={Edit}
                        buttonText="Редактировать присутствие и оценки"
                        additionalStyle="flex-1 text-valley-gray border-valley-gray px-4 py-2 text-sm font-semibold"
                        onClick={handleEditClick}
                    />
                ) : (
                    <div className="flex flex-1 gap-2">

                        <DefaultButton
                            buttonText="Отмена"
                            additionalStyle="text-valley-red border border-valley-red px-4 py-2 hover:bg-valley-red/10"
                            onClick={handleCancelEdit}
                        />
                        <DefaultButton
                            buttonText="Сохранить"
                            additionalStyle="text-white bg-valley-dark-green px-4 py-2 hover:bg-valley-dark-green/90"
                            onClick={handleSaveChanges}
                        />
                       
                    </div>
                )}
            </div>

            <div className="overflow-x-auto">
                <table className="w-full border-collapse mt-4 rounded-lg overflow-hidden text-md">
                    <thead className="text-valley-gray font-medium text-sm">
                        <tr className="bg-white">
                            <th className="text-left px-4 py-2 border-b">№</th>
                            <th 
                                className="text-left px-4 py-2 border-b cursor-pointer"
                                onClick={() => handleSort('name')}
                            >
                                <div className="flex items-center gap-2">
                                    Студент
                                
                                </div>
                            </th>
                            <th 
                                className="text-left px-4 py-2 border-b cursor-pointer"
                                onClick={() => handleSort('id')}
                            >
                                <div className="flex items-center gap-2">
                                    ID
                                   
                                </div>
                            </th>
                            <th 
                                className="text-left px-4 py-2 border-b cursor-pointer"
                                onClick={() => handleSort('presence')}
                            >
                                <div className="flex items-center gap-2">
                                    Присутствие
                                    
                                </div>
                            </th>
                            <th 
                                className="text-left px-4 py-2 border-b cursor-pointer"
                                onClick={() => handleSort('score')}
                            >
                                <div className="flex items-center gap-2">
                                    Балл за урок
                                   
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedStudents.map((student, index) => (
                            <tr
                                key={student.id}
                                className="border-b border-gray-200 bg-white-500"
                            >
                                <td className="px-4 py-2 bg-white">{index + 1}</td>
                                <td className="px-4 py-2 bg-white">
                                    <div className="flex items-center gap-2">
                                        <Avatar user={student.student} />
                                        <span>
                                            {student.student.json_saved_data.firstname} {student.student.json_saved_data.lastname}
                                        </span>
                                    </div>
                                </td>
                                <td className="px-4 py-2 bg-white">{student.studentId}</td>
                                <td className="px-4 py-2 bg-white">
                                    {isEditMode ? (
                                        <select
                                            value={student.isLate ? 'late' : (student.isPresent ? 'yes' : 'no')}
                                            onChange={(e) => handlePresenceChange(student.id, e.target.value)}
                                            className="border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <option value="yes">Да</option>
                                            <option value="no">Нет</option>
                                            <option value="late">Опоздал</option>
                                        </select>
                                    ) : (
                                        <span className={
                                            student.isLate 
                                                ? 'text-yellow-500' 
                                                : (student.isPresent ? 'text-green-500' : 'text-red-500')
                                        }>
                                            {student.isLate ? 'Опоздал' : (student.isPresent ? 'Да' : 'Нет')}
                                        </span>
                                    )}
                                </td>
                                <td className="px-4 py-2 bg-white">
                                    {isEditMode ? (
                                        <input
                                            type="number"
                                            min="0"
                                            value={student.score}
                                            onChange={(e) => handleScoreChange(student.id, Number(e.target.value) || 0)}
                                            className="border border-gray-300 rounded-md px-2 py-1 w-20 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    ) : (
                                        <span>{student.score}</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}